export default __webpack_public_path__ + "static/lloyd-15bb095b8fcad96f9414c864be92ede4.svg";